import React from "react";
import { Chip, Divider, MenuItem, Stack, Typography } from "@mui/material";
import { GlassPanel, ModernTextField } from "../styledComponents";

const DATE_FIELD_WIDTH = { xs: "100%", md: "50%" };
const VALUE_FIELD_WIDTH = { xs: "66.6667%", md: "41.6667%" };
const UNIT_FIELD_WIDTH = { xs: "33.3333%", md: "25%" };

const LIPID_FIELDS = [
  { label: "Triglicéridos", name: "trigliceridos" },
  { label: "Colesterol total", name: "colesterolTotal" },
  { label: "Colesterol LDL", name: "colesterolLDL" },
  { label: "Colesterol HDL", name: "colesterolHDL" },
  { label: "Colesterol VLDL", name: "colesterolVLDL" },
];

const PerfilLipidico = ({ formValues, onChange }) => {
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    onChange(name, value);
  };

  const today = new Date().toISOString().split("T")[0];

  return (
    <GlassPanel>
      <Stack spacing={3}>
        <Stack spacing={1}>
          <Typography variant="overline" sx={{ letterSpacing: 3 }}>
            Análisis clínico
          </Typography>
          <Typography
            variant="h5"
            sx={{ fontWeight: "bold", color: "primary.main" }}
          >
            Perfil lipídico
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Registra los lípidos clave para entender el riesgo cardiovascular y
            perfilar estrategias personalizadas.
          </Typography>
          <Stack direction="row" spacing={1}>
            {["Fechas", "Valores", "Riesgo"].map((tag) => (
              <Chip key={tag} label={tag} size="small" variant="outlined" />
            ))}
          </Stack>
        </Stack>

        <Divider />

        <Stack spacing={3}>
          <ModernTextField
            label="Fecha del perfil"
            name="fechaPerfilLipidico"
            type="date"
            value={formValues.fechaPerfilLipidico || ""}
            onChange={handleInputChange}
            fullWidth
            inputProps={{ max: today }}
            InputLabelProps={{ shrink: true }}
            helperText="Última fecha registrada del estudio"
            sx={{ width: DATE_FIELD_WIDTH }}
          />

          {LIPID_FIELDS.map((field) => (
            <Stack key={field.name} spacing={1.5}>
              <Typography variant="subtitle2" color="text.secondary">
                {field.label}
              </Typography>
              <Stack
                direction={{ xs: "column", md: "row" }}
                spacing={2}
                sx={{ flexWrap: "wrap" }}
              >
                <ModernTextField
                  label="Valor"
                  name={field.name}
                  type="number"
                  value={formValues[field.name] || ""}
                  onChange={handleInputChange}
                  fullWidth
                  sx={{ width: VALUE_FIELD_WIDTH }}
                />
                <ModernTextField
                  select
                  label="Unidad"
                  name={`${field.name}Medida`}
                  value={formValues[`${field.name}Medida`] || "mg/dL"}
                  onChange={handleInputChange}
                  fullWidth
                  sx={{ width: UNIT_FIELD_WIDTH }}
                >
                  <MenuItem value="mg/dL">mg/dL</MenuItem>
                  <MenuItem value="mmol/L">mmol/L</MenuItem>
                </ModernTextField>
              </Stack>
            </Stack>
          ))}
        </Stack>
      </Stack>
    </GlassPanel>
  );
};

export default PerfilLipidico;
